const Backbone = require('backbone');
const VariationView = require('./variation');

module.exports = Backbone.View.extend({
	el: '.js-product-variation',

	events: {
		click: 'render',
		mouseover: 'checkAvailableFinish',
		'click .js-view-more-variations': 'viewMoreVariations'
	},
	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.setSelectedFinish);
		this.variations = this.model.get('variations');
		this.childViews = [];
		if (this.variations.length) {
			this.variations.forEach((variation) => {
				this.childViews.push(
					new VariationView({
						el: `.js-variation[data-variation-id=${variation.variationId}]`,
						model: variation
					})
				);
			});
		}

		// Help me choose link
		if (window.BCOM.device.isMobile) {
			$('.js-help-me-choose').click(function() {
				$('.js-help-me-choose-content').slideToggle();
				$('.js-help-me-choose-close').toggleClass('rotate-180');
			});
		}
	},

	setSelectedFinish: function(finish) {
		if (finish.isPaint && finish.status.toLowerCase() !== 'nonstock') {
			$.each(
				$('.js-product-variation'),
				function(index, variation) {
					let $variation = $(variation);
					let product = this._getSelectedProduct($variation.data('variationid'), $variation.data('productcompositeid'));
					if (product && Array.isArray(product)) {
						product = product[0];
						if (product && product.productDrop.finishes.length !== 0) {
							const foundFinish = product.productDrop.finishes.find(function(ele) {
								return ele.finish === finish.name;
							});
							$variation.toggleClass('not-available', !foundFinish);
						}
					}
				}.bind(this)
			);
		}
	},

	_getSelectedVariation: function(variationId) {
		var selectedVariation = this.model.get('variations').filter(function(variation) {
			return variation.variationId === variationId;
		});

		return selectedVariation;
	},

	_getSelectedProduct: function(variationId, productCompositeId) {
		var variationProduct = this._getSelectedVariation(variationId)[0].variationProducts.filter(function(product) {
			if (product.productDrop) {
				return product.productDrop.productCompositeId === productCompositeId;
			}
		});

		return variationProduct;
	},

	_getAvailableFinish: function(product) {
		var availableFinish = product.productDrop.finishes.filter(function(finish) {
			if (window.dataLayer.selectedFinishName) {
				return finish.finish === window.dataLayer.selectedFinishName;
			}
		});
		return availableFinish;
	},

	checkAvailableFinish: function(event) {
		event.preventDefault();
		let $variation = $(event.target);
		if (!$variation.hasClass('paint')) {
			return;
		}

		let variationId = $variation.data('variationid'),
			productCompositeId = $variation.data('productcompositeid'),
			product = this._getSelectedProduct.call(this, variationId, productCompositeId)[0],
			availableFinish = this._getAvailableFinish.call(this, product);
		if (!availableFinish || availableFinish.length === 0) {
			const availableFinisNames = product.productDrop.finishes
				.map(function(elem) {
					return elem.finish;
				})
				.join(', ');
			$variation
				.tooltip({
					title: `This size is available in ${availableFinisNames} finish only`,
					placement: 'top'
				})
				.tooltip('show');
		}
	},
	render: function(event) {
		event.preventDefault();
		let $variation = $(event.target);
		if ($variation.hasClass('paint')) {
			return this.renderPaintVariations(event);
		}

		const variationId = $variation.data('variationid'),
			productCompositeId = $variation.data('productcompositeid'),
			product = this._getSelectedProduct.call(this, variationId, productCompositeId)[0],
			availableFinish = this._getAvailableFinish.call(this, product),
			data = {},
			trackingString = $variation.data('omniture').replace(/\s+/g, '-');

		data.linkName = trackingString;
		Backbone.trigger('track:link', data);

		if (!window.dataLayer.selectedFinishName || window.dataLayer.selectedFinishName === 'Choose Finish' || !availableFinish.length) {
			window.location.assign(product.productDrop.url);
		} else {
			let url = window.BCOM.util.updateURLParameters(product.productDrop.url, 'uid', availableFinish[0].uniqueId);
			if (window.BCOM.theme.isNiche) {
				// niche sites use product ID in the URL, not family ID + UID
				url = url.replace(/(p[\d]+)/g, `p${availableFinish[0].uniqueId}`);
			}
			window.location.assign(url);
		}
	},
	renderPaintVariations: function(event) {
		event.preventDefault();
		const $variation = $(event.target),
			variationId = $variation.data('variationid'),
			productCompositeId = $variation.data('productcompositeid'),
			product = this._getSelectedProduct.call(this, variationId, productCompositeId)[0],
			availableFinish = this._getAvailableFinish.call(this, product);

		let variationLink =
			!window.dataLayer.selectedFinishName || window.dataLayer.selectedFinishName === 'Choose Finish' ? product.productDrop.url : '';

		if (!variationLink && availableFinish.length) {
			variationLink = window.BCOM.util.updateURLParameters(product.productDrop.url, 'uid', availableFinish[0].uniqueId);
		}

		// Variation not available do nothing
		if ($variation.hasClass('not-available')) {
			return;
		}

		if (variationLink) {
			$.when(
				$.ajax(`${variationLink + (variationLink.indexOf('?') === -1 ? '?' : '&')}paintpartial=true`),
				$.ajax(`${variationLink + (variationLink.indexOf('?') === -1 ? '?' : '&')}datalayer=true`)
			).then(
				function(variationPartial, datalayer) {
					const datalayerResponse = Array.isArray(datalayer) ? datalayer[0] : datalayer;
					const variationPartialResponse = Array.isArray(variationPartial) ? variationPartial[0] : variationPartial;
					if (datalayerResponse && Array.isArray(availableFinish) && variationPartialResponse) {
						window.dataLayer = Object.assign(window.dataLayer, datalayerResponse);
						$('.paint-product-container').html(variationPartialResponse);

						// Delegate all the events to rebind to the DOM.
						window.BCOM.views.baseView.pageView.refreshView(window.dataLayer);
						window.BCOM.views.baseView.compareWidgetView.initButtons();

						// Update URL and browser history without page refresh.
						if (window.history.pushState) {
							window.history.replaceState({}, '', variationLink);
						}

						// Force trigger selecting the finish
						if (availableFinish && Array.isArray(availableFinish) && availableFinish.length) {
							$(`.js-finish-${availableFinish[0].uniqueId}`).trigger('click');
						}

						if (!window.dataLayer.selectedFinishName) {
							$('.js-gallery-thumbnail.gallery-thumbnail').trigger('mouseover');
						}
					} else {
						window.BCOM.notifications.render(
							'An error occurred trying to obtain product variation data. Please try your request again.',
							'warning'
						);
					}
				},
				function() {
					window.BCOM.notifications.render(
						'An error occurred trying to obtain product variation data. Please try your request again.',
						'warning'
					);
				}
			);
		}
	}
});
